import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/app/(with-header-footer)/page.module.css");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/ad-trial/ad-trial.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/main/disclaimer/disclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/main/important/important.tsx");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/main/logos/logos.module.css");
;
import(/* webpackMode: "eager" */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/main/learn/learn.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/main/search/search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ghadygergis/Documents/scitrials-sst/packages/website/src/components/share-social/share-social.tsx");
